module.exports = __webpack_public_path__ + "media/application/images/icons/1-green-5a0746a7819f8f6fbb11563e87d1c0ee.svg";